export default "__VITE_ASSET__D7W7i7fs__"